import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

// import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({});

class RingSplash extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
    super(props);
    this.state = {

    };
	}

	componentDidMount() {
    document.title = 'Diamonds Direct';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  splashNav(sku) {
    this.internalNav('jewelry/' + sku);
  }

	render() {
		return <div className='RingSplash'>
      <div className='rsTop'>
        <div className='rsTopWrapper'>
          <div className='rsTopTitle'>Fine Details</div>
          <div className='rsTopCopy'>A gorgeous Simon G. ring features swirls and milgrain detail with white and yellow diamonds.</div>
          <div className='rsTopButtonWrapper'>
            <button className='rsTopButton' onClick={() => this.splashNav('BLDXL09226')}>Shop this Ring</button>
          </div>
        </div>
      </div>
      <div className={'rsMid rsMid1'}>
        <div className={'rsMidLeft rsMidImg'}></div>
        <div className={'rsMidRight rsMidBody'}>
          <div className='rsMidBodyWrapper'>
            <div className='rsMidBodyImg'>
              <img src='https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/ring/statement.png' />
            </div>
            <div className='rsMidBodyTitle'>Statement Rings</div>
            <div className='rsMidBodyCopy'>This sterling silver Tacori ring features a bold blue topaz stone in a six prong setting.</div>
            <div className='rsMidBodyButtonWrapper'>
              <button className='rsMidBodyButton' onClick={() => this.splashNav('TACSS00093')}>Shop this Ring</button>
            </div>
          </div>
        </div>
      </div>
      <div className={'rsMid rsMid2'} style={{margin: '0'}}>
        <div className={'rsMidRight rsMidImg rsMidImgMobile'}></div>
        <div className={'rsMidLeft rsMidBody'}>
          <div className='rsMidBodyWrapper'>
            <div className='rsMidBodyImg'>
              <img src='https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/ring/bands.png' />
            </div>
            <div className='rsMidBodyTitle'>Diamond Bands</div>
            <div className='rsMidBodyCopy'>A classic ring showcasing five clusters of dazzling round brilliant diamonds.</div>
            <div className='rsMidBodyButtonWrapper'>
              <button className='rsMidBodyButton' onClick={() => this.splashNav('BLDXL06325')}>Shop this Ring</button>
            </div>
          </div>
        </div>
        <div className={'rsMidRight rsMidImg rsMidImgDesktop'}></div>
      </div>
      <div className='rsBottom'>
        <div className='rsBottomWrapper'>
          <div className='rsBottomTitle'>Gemstone Rings</div>
          <div className='rsBottomCopy'>This ring is elegant and striking with an eye-catching pear shaped blue sapphire.</div>
          <div className='rsBottomButtonWrapper'>
            <button className='rsBottomButton' onClick={() => this.splashNav('SAPPH02930')}>Shop this Ring</button>
          </div>
        </div>
      </div>
		</div>;
	}
}
export default RingSplash;

function mapStateToProps(state) {
  return {

  };
}

export const RingSplashContainer = connect(
  mapStateToProps,
  allActionCreators
)(RingSplash);


// WEBPACK FOOTER //
// ./src/components/views/gallery/blocks/splash/RingSplash.jsx